export default __webpack_public_path__ + "static/media/SS.b5e0cf5e.svg";